import { render, staticRenderFns } from "./LeakageCauseCommonAreaQuestion.vue?vue&type=template&id=e0b32c96&scoped=true"
import script from "./LeakageCauseCommonAreaQuestion.vue?vue&type=script&lang=ts"
export * from "./LeakageCauseCommonAreaQuestion.vue?vue&type=script&lang=ts"
import style0 from "./LeakageCauseCommonAreaQuestion.vue?vue&type=style&index=0&id=e0b32c96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b32c96",
  null
  
)

export default component.exports